import { IFitCcWorkbookSheet } from './fit-cc-iworkbook-sheet';

export interface IFitCcWorkbook
{
    filename: string;
    sheets: IFitCcWorkbookSheet [];
}